<template>
  <div>
    <!-- 设置 -->
    <div class="link-wrap">
    <div class="setting">
       <Card class="setting-card" 	 :dis-hover="false" :bordered="false">
            <h1>
              <span>Neal主题配置工具</span>
            </h1>
           
            <div class="form">

             <div class="form-item">
                <div class="form-lable">分类</div>
                <div class="form-input">
                    <Input v-model="type" value="type" placeholder="输入友链的分类名称"></Input>
                </div>
              </div>

              <div class="form-item">
                <div class="form-lable">名称</div>
                <div class="form-input">
                    <Input v-model="option.name" value="option.name" placeholder="输入友链的名称"></Input>
                </div>
              </div>
              <div class="form-item">
                <div class="form-lable">链接</div>
                <div class="form-input">
                    <Input v-model="option.url" value="option.url" placeholder="输入友链的链接"></Input>
                </div>
              </div>
              <div class="form-item">
                <div class="form-lable">图片</div>
                <div class="form-input">
                    <Input v-model="option.img" value="option.img" placeholder="输入友链的图片"></Input>
                </div>
              </div>
              <div class="form-item">
                <div class="form-lable">说明</div>
                <div class="form-input">
                    <Input v-model="option.info" value="option.info" placeholder="输入友链的说明"></Input>
                </div>
              </div>
              <Button class="add" type="primary" @click="handleAdd()">
                新增
                   <Icon type="md-add" />
               </Button>
            </div>
        </Card>
    </div>
     <div class="link-rader">

           <Button class="copy" type="primary"  
            v-clipboard:copy="JSON.stringify(list)" 
            v-clipboard:success="onCopy" 
            v-clipboard:error="onError"> 
            复制代码
                  <Icon  type="md-clipboard" />
            </Button>

        <Card class="link-card" @click="moveLinkCard(index)" v-dragging="{ item: item, list: list, group: 'item' }" v-for="(item,index) in list" v-bind:key="index" :dis-hover="false" :bordered="false">
          <div class="">
            <h2>{{item.name}}</h2>
            <div class="list">
              <div class="list-item" @click="handleClick(items,item.name)" v-for="(items,i) in item.item" v-bind:key="i">
                <Icon class="delete" @click.stop="handleDelete(index,i)" type="ios-close-circle" />
                <div class="mask"></div>
                <p class="R1">
                  <img class="img" :src="items.img" alt="">
                  <label class="title">{{items.name}}</label>
                </p>
                <p class="R2">{{items.info}}</p>

              </div>

            </div>
          </div>
        </Card>
     </div>
  </div>
  <!-- 设置结束 -->

  <!-- 推荐 -->
  
    <div class="link-wrap" style="display:block">
       <h1 style="margin-bottom:10px">推荐网站</h1>
      <div class="link-rader">

            <Button class="copy" type="primary" @click="pushAll()"> 
                    全部加入<Icon  type="md-clipboard" />
              </Button>

          <Card class="link-card" v-for="(item,index) in default_list" v-bind:key="index" :dis-hover="false" :bordered="false">
            <div class="">
              <h2>{{item.name}}</h2>
              <div class="list">
                <div class="list-item" @click="handleClick(items,item.name)" v-for="(items,i) in item.item" v-bind:key="i">
                  <Icon class="delete"  @click.stop="handleCart(item.name,items.name,items.img,items.url,items.info)" type="md-cart" />
                  <div class="mask" @click="openWindow(items.url)"></div>
                  <p class="R1">
                    <img class="img" :src="items.img" alt="">
                    <label class="title">{{items.name}}</label>
                  </p>
                  <p class="R2">{{items.info}}</p>

                </div>

              </div>
            </div>
          </Card>
      </div>
    </div>
    <!-- 推荐结束 -->
     <BackTop></BackTop>
  </div>
</template>
<script>
import config from "../utils/default"
    export default {
      name:'linkConfig',
      data(){
        return{
          option:{
            name:'',
            url:'',
            img:'',
            info:''
          },
          type:'',
            list:[],
            default_list:[]
        }
      },
      mounted(){
        this.list = JSON.parse(localStorage.getItem("list")) || config.default_link
        this.default_list = config.list
      },
      methods:{
        pushAll(){
          this.list = this.default_list
           localStorage.setItem("list",JSON.stringify(this.list))

        },
        openWindow(url){
          window.open(url)
        },
        onCopy(){
          this.$Message.success("复制成功")
        },
        onError(){
          this.$Message.errot("复制失败")
        },
        handleClick(item,type){
          this.type = type
          this.$set(this.option,'name',item.name)
          this.$set(this.option,'img',item.img)
          this.$set(this.option,'url',item.url)
          this.$set(this.option,'info',item.info)
        },
        handleDelete(type_index,item_index){
          let list = this.list 
          if(list[type_index].item.length>1){
            //如果分类中的item大于1
            list[type_index].item.splice(item_index,1)
          }else{
            list.splice(type_index,1)
          }
          this.list = list
        },
        handleAdd(){
          let type = this.type
          let name = this.option.name
          let img = this.option.img
          let url = this.option.url
          let info = this.option.info
          if(!type || !name || !img || !url || !info){
            return   this.$Message.error('数据不能为空，请检查输入！');
          }
          let list = this.list
          let isLiveType =  this.isLiveType(list,type)
          if(isLiveType == null){
            // 监测到新类别，新增分类
            list.push({name:type,icon:"url",item:[]})
            this.list = list
          
           localStorage.setItem("list",JSON.stringify(this.list))

          }
          //判断该item是否存在
          let isLiveItem = this.isLiveItem(list,type,name)
          if(isLiveItem==null){
            //监测到新item，新增item
            let type_index = this.isLiveType(list,type)
            this.listItemPush(type_index,{
              name:name,img:img,url:url,info:info
            })
          }else{
            this.$Message.error('已存在同名友链')
          }
         
        },
        handleCart(type,name,img,url,info){

          let list = this.list
          let isLiveType =  this.isLiveType(list,type)
          if(isLiveType == null){
            // 监测到新类别，新增分类
            list.push({name:type,icon:"url",item:[]})
            this.list = list
          
           localStorage.setItem("list",JSON.stringify(this.list))

          }
          //判断该item是否存在
          let isLiveItem = this.isLiveItem(list,type,name)
          if(isLiveItem==null){
            //监测到新item，新增item
            let type_index = this.isLiveType(list,type)
            this.listItemPush(type_index,{
              name:name,img:img,url:url,info:info
            })
          }else{
            this.$Message.error('已存在同名友链')
          }
         
        },
        //新增item
        listItemPush(index,object){
          this.list[index].item.push(object)
          localStorage.setItem("list",JSON.stringify(this.list))
        },
        //分类是否存在
        isLiveType(list,type){
          let  r_index  = null
           list.forEach((item,index)=>{
            if(item.name == type){
             r_index = index
            }
          })
          return r_index
        },
        // item是否存在
        isLiveItem(list,type,query_name){
          let r_index = null
           list.forEach((item,index)=>{
            if(item.name == type){
              let ul = item.item
              ul.forEach((a,i)=>{
                if(a.name==query_name){
                  r_index = {type:index,item:i}
                }
              })
            }
          })
          return r_index
        }
      }
    }
</script>
<style lang="less" scoped>
.link-wrap{
  min-width: 750px;
  margin: 0 auto;
  display: flex;
  padding-top: 40px;
  @media screen and (max-width: 1200px){
    display: block;
    min-width: 100%;
  }
  /* background: ; */
  .setting{
    width: 600px;
    padding-right: 20px;
    @media screen and (max-width: 1200px){
     width: 100%;
     padding-right: 0px;
     margin-bottom: 20px;
    }
    .setting-card{
      border-radius: 7px;
      box-shadow: 0px 0px 30px #eeeeee;
      
      h1{
        vertical-align: middle;
        span{
          display:inline-block;
          vertical-align: middle;
          margin-right: 10px;
        }
        button{
        display:inline-block;
        vertical-align: middle;
       
      }
      }
      .form{
        width: 100%;
        margin-top: 40px;
      
        .form-item{
          display: flex;
          margin-bottom: 10px;
          .form-lable{
            width: 100px;
            line-height: 32px;
          }
          .form-input{
            flex: 1;
          }
        }
      }
    }
  }
  .link-rader{
    background:#eee;
    padding: 20px;
    min-height:358px;
    position:relative;
    flex: 1;
    @media screen and (max-width: 1200px){
     width: 100%;
    }
    &:hover{
      .copy{
        display: block;
        transition: all 0.3s;
       
      }
    }
  }
  .copy{
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 2000;
    outline: none;
    display: none;
    transition: all 0.3s;
  }
  .link-card{
    text-align: left;
    flex: 1;
    min-width: 600px;
    margin-bottom: 20px;
    @media screen and (max-width: 1200px){
      min-width: 100%;
    }
    .list{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      @media screen and (max-width: 1200px){
          display: flex;
        }
      .list-item{
        position: relative;
        cursor: pointer;
        width: 200px;
        border-radius: 2px;
        background: #fff;
        padding: 10px;
        width: 20%;
        min-width: 200px;
        margin: 22px 0 0 2.1%;
        float: left;
        overflow: hidden;
        border: 1px solid #e4ecf3;
        box-shadow: 1px 2px 3px #f2f6f8;
        transition: all .3s;
        @media screen and (max-width: 1200px){
          width: 100%;
        }
        &:hover{
          border-color: #6495ed;
          transition: all .3s;
          .delete{
            display: block;
           transition: all 0.3;

          }
        }
        .delete{
          position: absolute;
          z-index: 2000;
          right:6px;
          top: 6px;
          font-size: 20px;
          opacity: 0.5;
          display: none;
          transition: all 0.3;
        }
        .mask{
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          right: 0;
          top:0;
          bottom: 0;
          margin: auto auto;
        }
        .img{
          width: 40px;
          height: 40px;
        }
       .R1{
         width: 100%;
         display: flex;
         line-height: 40px;
         font-size: 14px;
        font-weight: 700;
        color: #3273dc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 .1rem;
        .title{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 0.1rem;
          margin-left: 5px;
        }
       } 
       .R2{
         width: 100%;
          color: grey;
          font-size: 12px;
          padding-top: 10px;
          height: 45px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
       }
      }
      
    }
  }

}


</style>